
/* styles */
require("!!vue-style-loader!css-loader?{\"minimize\":false,\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index?{\"id\":\"data-v-6ca927d4\",\"scoped\":true,\"hasInlineConfig\":false}!sass-loader?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./SideButtons.vue")

var Component = require("!../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./SideButtons.vue"),
  /* template */
  require("!!../../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-6ca927d4\"}!../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./SideButtons.vue"),
  /* scopeId */
  "data-v-6ca927d4",
  /* cssModules */
  null
)
Component.options.__file = "/github/workspace/src/tools/modal/ReservationEditV2/SideButtons.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] SideButtons.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (module.hot) {(function () {
  var hotAPI = require("vue-loader/node_modules/vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-6ca927d4", Component.options)
  } else {
    hotAPI.reload("data-v-6ca927d4", Component.options)
  }
})()}

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/tools/modal/ReservationEditV2/SideButtons.vue
// module id = 217
// module chunks = 0